import SignUpTemplate from './SignUpTemplate'

export default SignUpTemplate
